import React, { useState } from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Textarea,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { MdCall } from "react-icons/md";
import api from "utils/apiService";
import { toast } from "react-toastify";
const Message = ({ data, refetch }) => {
  const handleDelete = async () => {
    try {
      const res = await api.delete(`/supportMessages/${data.id}`);
      if (res.error) {
        toast.error(res.error);
      } else {
        refetch();
        toast.success("تم حذف الرسالة بنجاح");
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button
          className="my-4 rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear"
          variant="outline"
          size="sm"
        >
          الرسالة
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="flex w-full items-center justify-between text-xl font-bold">
            <span>الرسالة الكاملة</span>
            <a
              title={`tel:${data?.user?.phoneNumber}`}
              href={`tel:${data?.user?.phoneNumber}`}
            >
              <MdCall className="text-3xl text-blue-500 hover:text-blue-400" />
            </a>
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-4">
            <div>
              <span className="inline-block font-bold me-2">المستخدم:</span>
              <span>{data?.user?.name}</span>
            </div>
            <div>
              <span className="inline-block font-bold me-2">الرقم:</span>
              <span>{data?.user?.phoneNumber}</span>
            </div>
            <div>
              <span className="mb-2 block font-bold">الرسالة:</span>
              <Textarea
                value={data?.message}
                readOnly
                className="w-full resize-none border border-dashed p-2 outline-0"
                rows={7}
              />
            </div>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            onClick={handleDelete}
            variant="outline"
            className="text-red-400"
          >
            <span>انهاء الشكوى</span>
          </Button>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default Message;
